import type { ReactNode } from 'react';
import clsx from 'clsx';
import { FiBox, FiClipboard } from 'react-icons/fi';

import { Group } from '@highlight-cp/core-ui';
import type { GroupProps } from '@highlight-cp/core-ui';

import { TIMELINE_BAR_HEIGHT } from './constants';
import classes from './timeline-bar.module.css';
import paletteClasses from './timeline-palette.module.css';

/** Sets the timeline's colour variables on an element, for blocks and bars drawn inside it. */
export const TIMELINE_PALETTE_CLASS_NAME = paletteClasses.palette;

export interface TimelineBarProps extends Omit<GroupProps, 'children'> {
  kind: 'product' | 'survey';
  /** Its label, after its icon. */
  children: ReactNode;
  /** After the label, outside its truncation: a note, or the builder's controls. */
  trailing?: ReactNode;
}

/** A product's use or a survey on a day timeline, drawn inside `TIMELINE_PALETTE_CLASS_NAME`. */
export const TimelineBar = ({
  kind,
  children,
  trailing,
  className,
  mod,
  ...groupProps
}: TimelineBarProps) => {
  const Icon = kind === 'product' ? FiBox : FiClipboard;

  return (
    <Group
      bdrs="sm"
      fz="xs"
      gap={6}
      h={TIMELINE_BAR_HEIGHT}
      px={6}
      wrap="nowrap"
      {...groupProps}
      className={clsx(classes.bar, className)}
      mod={[{ product: kind === 'product' }, mod]}
    >
      <Group flex={1} gap={4} miw={0} wrap="nowrap">
        <Icon aria-hidden className={classes.icon} size={14} />
        {children}
      </Group>
      {trailing}
    </Group>
  );
};
